import { render, staticRenderFns } from "./ExamStudentForm.vue?vue&type=template&id=2ee32400&scoped=true"
import script from "./ExamStudentForm.vue?vue&type=script&lang=js"
export * from "./ExamStudentForm.vue?vue&type=script&lang=js"
import style0 from "./ExamStudentForm.vue?vue&type=style&index=0&id=2ee32400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee32400",
  null
  
)

export default component.exports